import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Col, Drawer, notification, Row } from 'antd';
import { bookImage, isAdmin, podcastHrefUrl, podcastSlugUrl } from '../../lib/utils';
import AppCustomLink from './AppCustomLink';
import EpisodeDrawer from './EpisodeDrawer';
import { getIsPremiumUser } from '../../lib/fileUtils';
import { getBrowsePodcasts, retrieveAppInfo } from '../../actions';
import AppAlertDiv from './AppAlertDiv';
import ChapterImage from './ChapterImage';

class ForYouHome extends Component {
    componentDidMount() {
        const { forYouEpisodes, dbPodcastState, userDetails } = this.props;
        console.dir(userDetails);
        if (!userDetails || !userDetails.uid) {
            this.props.getBrowsePodcasts('11', true);
        }
    }

    render() {
        const { forYouEpisodes, dbPodcastState, userDetails } = this.props;
        // console.dir(forYouEpisodes);
        // console.dir(userDetails);
        const episodes = Object.values(forYouEpisodes);
        // final PodcastEpisode episode =
        // forYouHomeEpisodes.values.toList()[index - 1];

        return (
            <div>
                <h3>Personalized For You</h3>
                <hr className='separator' />

                {(!userDetails || !userDetails.uid) ? <div>
                    <AppAlertDiv message={`Your personalized key ideas will show up here.`} showIcon />

                </div> : <></>}

                {episodes.map((ep, ind) => (
                    <div key={ind}>
                        <EpisodeCardForYou episode={ep} userDetails={userDetails} dbPodcastState={dbPodcastState} />
                    </div>
                ))}
            </div>
        )
    }
}
class EpisodeCardForYou extends Component {
    constructor(props) {
        super(props);
        this.state = { visibleDrawer: false };
    }

    onDrawerOpen = (podcastEpisode) => {
        const appInfoLoc = retrieveAppInfo();
        const { userDetails, episode } = this.props;
        console.dir(appInfoLoc);
        const isFreeBook = appInfoLoc.bookOfDay && appInfoLoc.bookOfDay.collectionId == podcastEpisode.collectionId;
        console.dir(isFreeBook);
        console.dir(isAdmin(userDetails));
        if (!isFreeBook && !isAdmin(userDetails) && !getIsPremiumUser()) {
            console.dir(appInfoLoc);
            notification.info({
                // duration: 0,
                message: 'Please move to premium version to view the summary.',
            });
            return;
        }
        console.dir(appInfoLoc);
        console.dir(episode);
        this.setState({
            visibleDrawer: true,
        });
    };

    onDrawerClose = () => {
        this.setState({
            visibleDrawer: false,
        });
    };
    render() {
        const { dbPodcastState, userDetails, episode } = this.props;
        const { visibleDrawer } = this.state;
        const podcast = dbPodcastState[episode.collectionId] ??
            dbPodcastState['${episode.collectionId}'] ??
            {};
        // console.dir(visibleDrawer);
        return <div className='main'>
            {visibleDrawer &&
                <EpisodeDrawer podcastEpisode={episode}
                    podcastEpisodes={[episode]}
                    userDetails={userDetails}
                    rawTokenCount={{}} onDrawerClose={this.onDrawerClose} />
            }
            <div style={{ cursor: 'pointer', maxWidth: '680px', margin: 'auto' }} onClick={this.onDrawerOpen.bind(this, episode)}>
                <h3>{episode.title}</h3>
                <div>
                    <ChapterImage collectionId={episode.collectionId}
                        width={'100%'}
                        thumbnail={episode.thumbnail || ''} />
                </div>
                <p className='serif' style={{ fontSize: '1.1em' }}>{episode.description.length > 300 ? episode.description.slice(0, 300) + '...' : episode.description}</p>
            </div>
            <AppCustomLink href={podcastHrefUrl(podcast.collectionId)} as={podcastSlugUrl(podcast.collectionName, podcast.collectionId)}>
                <Row style={{ margin: 'auto', maxWidth: '400px', marginTop: '2em', cursor: 'pointer' }}>
                    <Col xs={7} md={6}>
                        <img src={bookImage(podcast)} alt={`${podcast.collectionName || ''} book`} />
                    </Col>
                    <Col xs={16} md={17} style={{ margin: 'auto' }}>
                        <h3>{podcast.collectionName.length > 60 ? podcast.collectionName.slice(0, 60) + '...' : podcast.collectionName}</h3>
                        <h4>{podcast.artistName}</h4>
                    </Col>
                </Row>
            </AppCustomLink>

            <style jsx>
                {`
            .main {
                background: #${podcast.bgColor}66;
                padding: 2em 2em;
                margin-bottom: 2em;
                border-radius: 12px;
                box-shadow: 0 20px 40px 0 rgba(0, 11, 40, .04);
            }
                img {
                max-width: 100%;
                }
           `}
            </style>
        </div>
    }
}

EpisodeCardForYou.propTypes = {
    dbPodcastState: PropTypes.object,
    userDetails: PropTypes.object,
    episode: PropTypes.object,
    // showMore: PropTypes.bool,
    // fetchHomeMainPodcasts: PropTypes.func,
}
ForYouHome.propTypes = {
    forYouEpisodes: PropTypes.object,
    dbPodcastState: PropTypes.object,
    userDetails: PropTypes.object,
    // showMore: PropTypes.bool,
    getBrowsePodcasts: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        forYouEpisodes: state.forYouEpisodes,
        dbPodcastState: state.dbPodcastState,
        userDetails: state.userDetails,
        // userPlaylists: state.userPlaylists,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getBrowsePodcasts: bindActionCreators(getBrowsePodcasts, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForYouHome);
